import { ExternalLink } from "lucide-react";

interface Source {
  title: string;
  url: string;
}

interface SourcesPaneProps {
  sources: Source[];
}

export default function SourcesPane({ sources }: SourcesPaneProps) {
  return (
    <ul className="space-y-1 list-disc list-inside">
      {sources.map((source, idx) => (
        <li key={idx} className="text-sm">
          <a
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-primary hover:underline"
          >
            {source.title}
            <ExternalLink className="h-3 w-3" />
          </a>
        </li>
      ))}
    </ul>
  );
}
